import React from "react";

import { 
	Box, 
	Container, 
	Grid, 
	Typography 
} from "@mui/material";
import { Trans } from "@lingui/macro";
import * as MUIcon from "@mui/icons-material";
import { ActionFigure } from "components/backoffice/action-figure/action-figure";
import { NavigationBack } from "commons";

interface Action
{
	href: string
	icon: keyof typeof MUIcon
	description: string
	descriptionId: string
}
const ACTION: Action[] = [
	{
		href: "/backoffice/manage-subscription",
		icon: "CardMembership",
		description: "Abbonamenti",
		descriptionId: "sa-subscription-management-card"
	},
	/*{
		href: "/backoffice/manage-coupon",
		icon: "CardGiftcard",
		description: "Codici Sconto e Regalo",
		descriptionId: "sa-coupon-management-card"
	}*/
];

export class SubscriptionActions extends React.Component<{}, {}>
{
	render() {
		return (<Box p={5}>
			<NavigationBack />
			<Box textAlign="center" marginBottom={8}>
				<Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
					<Trans id="sa-subscription-actions-title">Codici e abbonamenti</Trans>
				</Typography>
			</Box>
			<Container maxWidth="lg">
				<Grid container rowSpacing={10}>
					{ACTION.map((item, i) => (
						<Grid item xs={12} md={6} lg={4}
              key={i} 
              display="flex" 
              justifyContent="center" 
              alignItems="center"
            >
              <ActionFigure href={item.href} icon={item.icon} description={item.description} descriptionId={item.descriptionId}/>
						</Grid>
					))}
				</Grid>
			</Container>
		</ Box>);
	}
}
